



















import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import Histogram from '@/trials/views/components/Histogram.vue';
import BarChart from '@/trials/views/components/BarChart.vue';
import TrainColumn from '@/trials/domain/objects/trainColumn';

@Component({ components: { Histogram, BarChart } })
export default class TrainDataStatisticsLabels extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/

    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private labelColumn: TrainColumn | null = null;
    private data: any = {};
    private categories: any[] = [];
    private colors: string[] = [SC.Color.NEGATIVE, SC.Color.POSITIVE];
    private labelName: string = '';

    /*----------------------------------*
     * Computed
     *-----------------------------------*/

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        // labelのcolumnデータ取得
        const columns: TrainColumn[] = sessionModule.getTrainDataStatistics;
        this.labelColumn = columns.filter((column: TrainColumn) => {
            return column.isLabel;
        })[0];

        // カテゴリデータを生成
        this.categories = Object.keys(this.labelColumn.data);
        this.categories.sort();

        // BarChartに表示させるためのデータを生成
        // BarChartは文字列データ用ですが、見た目が良いので利用しています。
        // そのため、数値データ(labelは 0, 1 のみ)を文字列データ用の構造に変換しています。
        for (let i = 0; i < this.categories.length; i++) {
            const category = this.categories[i];
            this.data[category] = this.labelColumn.data[category].length;
        }

        // ラベル行に設定されたカラム名を保持
        this.labelName = sessionModule.getTrainingData.labelName;
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
}
